<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.editSchedule_header | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      (click)="cancel()"
      [attr.aria-label]="data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="schedule-container">
      @if (form.controls.scheduleWeeks.controls.length > 1) {
        <div class="field-container">
          <app-date-field
            [label]="data.sysText.alignmentDate | titlecase"
            [info]="data.sysText.alignmentDate_info"
            [control]="form.controls.alignmentDate"
            [icon]="'calendar_today'"
            [group]="form">
          </app-date-field>
        </div>
      }
      <div class="workday-headers">
        <span class="row-label body2 grey2"></span>
        <span class="span-cell body2 grey2">{{ data.sysText.sun | titlecase }}</span>
        <span class="span-cell body2 grey2">{{ data.sysText.mon | titlecase }}</span>
        <span class="span-cell body2 grey2">{{ data.sysText.tue | titlecase }}</span>
        <span class="span-cell body2 grey2">{{ data.sysText.wed | titlecase }}</span>
        <span class="span-cell body2 grey2">{{ data.sysText.thu | titlecase }}</span>
        <span class="span-cell body2 grey2">{{ data.sysText.fri | titlecase }}</span>
        <span class="span-cell body2 grey2">{{ data.sysText.sat | titlecase }}</span>
        @if (form.controls.scheduleWeeks.controls.length > 1) {
          <span class="button-spacer"></span>
        }
      </div>
      <div class="schedule-week-container">
        @for(weekFormGroup of form.controls.scheduleWeeks.controls; track weekFormGroup; let i = $index) {
          <div class="schedule-week">
            <div class="week-container">
              <div class="row">
                <span class="row-label body2 grey2">{{ data.sysText.scheduleWorkday }}</span>
                <mat-checkbox
                  class="span-cell"
                  [formControl]="weekFormGroup.controls.worksSunday"
                  [aria-label]="data.sysText.sun">
                </mat-checkbox>
                <mat-checkbox
                  class="span-cell"
                  [formControl]="weekFormGroup.controls.worksMonday"
                  [aria-label]="data.sysText.mon">
                </mat-checkbox>
                <mat-checkbox
                  class="span-cell"
                  [formControl]="weekFormGroup.controls.worksTuesday"
                  [aria-label]="data.sysText.tue">
                </mat-checkbox>
                <mat-checkbox
                  class="span-cell"
                  [formControl]="weekFormGroup.controls.worksWednesday"
                  [aria-label]="data.sysText.wed">
                </mat-checkbox>
                <mat-checkbox
                  class="span-cell"
                  [formControl]="weekFormGroup.controls.worksThursday"
                  [aria-label]="data.sysText.thu">
                </mat-checkbox>
                <mat-checkbox
                  class="span-cell"
                  [formControl]="weekFormGroup.controls.worksFriday"
                  [aria-label]="data.sysText.fri">
                </mat-checkbox>
                <mat-checkbox
                  class="span-cell"
                  [formControl]="weekFormGroup.controls.worksSaturday"
                  [aria-label]="data.sysText.sat">
                </mat-checkbox>
              </div>
              <div class="row">
                <span class="row-label body2 grey2">{{ data.sysText.scheduleHours }}</span>
                <app-input-field
                  class="hours-input"
                  [group]="form"
                  [hideIconSpace]="true"
                  [control]="weekFormGroup.controls.sundayHours"
                  [inputType]="'number'"
                  [isHintHighlighted]="false"
                  [isHintWarning]="true">
                </app-input-field>
                <app-input-field
                  class="hours-input"
                  [group]="form"
                  [hideIconSpace]="true"
                  [control]="weekFormGroup.controls.mondayHours"
                  [inputType]="'number'"
                  [isHintHighlighted]="false"
                  [isHintWarning]="true">
                </app-input-field>
                <app-input-field
                  class="hours-input"
                  [group]="form"
                  [hideIconSpace]="true"
                  [control]="weekFormGroup.controls.tuesdayHours"
                  [inputType]="'number'"
                  [isHintHighlighted]="false"
                  [isHintWarning]="true">
                </app-input-field>
                <app-input-field
                  class="hours-input"
                  [group]="form"
                  [hideIconSpace]="true"
                  [control]="weekFormGroup.controls.wednesdayHours"
                  [inputType]="'number'"
                  [isHintHighlighted]="false"
                  [isHintWarning]="true">
                </app-input-field>
                <app-input-field
                  class="hours-input"
                  [group]="form"
                  [hideIconSpace]="true"
                  [control]="weekFormGroup.controls.thursdayHours"
                  [inputType]="'number'"
                  [isHintHighlighted]="false"
                  [isHintWarning]="true">
                </app-input-field>
                <app-input-field
                  class="hours-input"
                  [group]="form"
                  [hideIconSpace]="true"
                  [control]="weekFormGroup.controls.fridayHours"
                  [inputType]="'number'"
                  [isHintHighlighted]="false"
                  [isHintWarning]="true">
                </app-input-field>
                <app-input-field
                  class="hours-input"
                  [group]="form"
                  [hideIconSpace]="true"
                  [control]="weekFormGroup.controls.saturdayHours"
                  [inputType]="'number'"
                  [isHintHighlighted]="false"
                  [isHintWarning]="true">
                </app-input-field>
              </div>
            </div>
            @if (form.controls.scheduleWeeks.controls.length > 1) {
              <button
                type="button"
                mat-icon-button
                [attr.aria-label]="data.sysText.remove_ariaLabel"
                [disableRipple]="true"
                (click)="onRemoveWeek(i)">
                <mat-icon class="no-margin accent">close</mat-icon>
              </button>
            }
          </div>
        }
      </div>
    </div>
  </form>
  <div class="bottom-section">
    <div aria-live="polite">
      @if (form.controls.scheduleWeeks.errors?.msError) {
        <mat-error class="mse-form-error caption bottom-hint">
          {{ form.controls.scheduleWeeks.errors?.msError }}
        </mat-error>
      }
    </div>
    <div class="button-container">
      <button
        #addWeekButton
        (click)="onAddWeek()"
        mat-flat-button
        color="accent"
        class="button">
        {{data.sysText.addAdditionalWeek | uppercase}}
      </button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!isSubmitting && this.form.errors?.msError) {
    <mat-error class="mse-form-error caption">{{ this.form.errors?.msError }}</mat-error>
  }
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>
